import { useState } from 'react';
import './ClientsFilter.css';
import { getAllClients } from '../../utilities/api/clients';

const defaultClientsFilters = {
    "province": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
}

const provinceOptions = [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NT",
    "NU",
    "ON",
    "PE",
    "QC",
    "SK",
    "YT",
]

export default function ClientsFilter({ user, updateClients, isMobile, sortHeader }) {
    const [filter, setFilter] = useState(defaultClientsFilters)
    const [loading, setLoading] = useState(false)

    const getClients = async () => {
        try {
            const allClients = await getAllClients(user._id)
            return allClients.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true)
        // clear content of all input fields
        const form = document.getElementById('clientsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultClientsFilters)
        const freshClientsData = await getClients();
        updateClients(freshClientsData)
        setLoading(false)
    }

    const filterClients = async () => {
        setLoading(true)
        const freshClientsData = await getClients();
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        const updatedClientsList = freshClientsData.filter(client => {
            return (
                (cleanedFilter.province ? client.province === cleanedFilter.province : true) &&
                (cleanedFilter.createdAtStart ? new Date(client.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                (cleanedFilter.createdAtEnd ? new Date(client.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                (cleanedFilter.updatedAtStart ? new Date(client.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                (cleanedFilter.updatedAtEnd ? new Date(client.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true)
            );
        });

        updateClients(updatedClientsList);
        setLoading(false)
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }
  return (
    <div className='ClientsFilter dropdown clientsFilterDropDown'>
        <button className='clientsFilterDropDownToggle' id='clientsFilterDropDownToggle' title='Clients Filter' data-title='Clients Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu clientsFilterDropDown' aria-labelledby="clientsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='clientsFilter'>
                <div className='form-group'>
                    <label htmlFor="province" className='form-label'>Province</label>
                    <select id="clientProvince" name='province' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { provinceOptions.map((province, index) => (
                            <option key={index} value={province}>{province}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterClients} form='clientsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='clientsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
        </div>
    </div>
  )
}
